module.exports = __webpack_public_path__ + "img/22.9ebbaf9f.webp";